var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcMenuCpaSelected(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4.12095,
    y: 3.42857,
    width: 17.1429,
    height: 17.1429,
    rx: 4,
    fill: "white",
    stroke: "#0E5CF4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9823 14.8955L16.1924 14.3628L16.4025 14.8955C16.4736 15.0759 16.6164 15.2187 16.7969 15.2899L17.3296 15.5L16.7968 15.7101C16.6164 15.7813 16.4736 15.9241 16.4025 16.1045L16.1924 16.6372L15.9823 16.1045C15.9111 15.9241 15.7683 15.7813 15.5879 15.7101L15.0552 15.5L15.5879 15.2899L15.4045 14.8248L15.5879 15.2899C15.7683 15.2187 15.9111 15.0759 15.9823 14.8955Z",
    stroke: "#0E5CF4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1924 7.3628L12.2032 9.9258C12.3049 10.1835 12.5089 10.3875 12.7666 10.4892L15.3296 11.5L12.7666 12.5108C12.5089 12.6125 12.3049 12.8165 12.2032 13.0742L11.1924 15.6372L10.1816 13.0742C10.0799 12.8165 9.8759 12.6125 9.61818 12.5108L7.05519 11.5L9.61818 10.4892C9.8759 10.3875 10.0799 10.1835 10.1816 9.9258L11.1924 7.3628Z",
    stroke: "#0E5CF4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcMenuCpaSelected);
export default __webpack_public_path__ + "static/media/ic-menu-cpa-selected.1978aaf48fe5e90300ee45242de4ce69.svg";
export { ForwardRef as ReactComponent };